import script from "./artist-operation.vue?vue&type=script&setup=true&lang=js"
export * from "./artist-operation.vue?vue&type=script&setup=true&lang=js"

import "./artist-operation.vue?vue&type=style&index=0&id=9f638efe&lang=scss&scoped=true"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f638efe"]])

export default __exports__